<template>
  <div>
    <div class="form" v-if="showForm">
      <div class="form-item">
        <div class="form-title">
          <div>企业基本信息</div>
          <el-button
            style="font-weight: bold; font-size: 16px; padding: 0;"
            type="text"
            icon="el-icon-back"
            @click="showForm = false"
          >
            返回列表
          </el-button>
        </div>
        <div class="form-content">
          <el-row class="form-row" :gutter="40">
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">企业名称：</div>
              <div class="form-content-value">{{ detailData.company_name }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">曾用名：</div>
              <div class="form-content-value">{{ detailData.used_company_name }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">法定代表人：</div>
              <div class="form-content-value">{{ detailData.corporation_name }}</div>
            </el-col>
          </el-row>
          <el-row class="form-row" :gutter="40">
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">统一社会信用代码：</div>
              <div class="form-content-value">{{ detailData.credit_code }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">组织机构代码：</div>
              <div class="form-content-value">{{ detailData.company_code }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">纳税人识别号：</div>
              <div class="form-content-value">{{ detailData.taxpayer_id_code }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="form-item">
        <div class="form-title">
          <div>企业联系方式</div>
        </div>
        <div class="form-content">
          <el-row class="form-row" :gutter="40">
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">所属省份：</div>
              <div class="form-content-value">{{ detailData.province_name }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">所属城市：</div>
              <div class="form-content-value">{{ detailData.city_name }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">所属区县：</div>
              <div class="form-content-value">{{ detailData.area_name }}</div>
            </el-col>
          </el-row>
          <el-row class="form-row" :gutter="40">
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">电话：</div>
              <div class="form-content-value">{{ detailData.contacts_mobile_phone }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">更多电话：</div>
              <div class="form-content-value">{{ detailData.more_tel }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">邮箱：</div>
              <div class="form-content-value">{{ detailData.contacts_mail }}</div>
            </el-col>
          </el-row>
          <el-row class="form-row" :gutter="40">
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">更多邮箱：</div>
              <div class="form-content-value">{{ detailData.more_mail }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">企业地址：</div>
              <div class="form-content-value">{{ detailData.address }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">网址：</div>
              <div class="form-content-value">{{ detailData.web_site }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="form-item">
        <div class="form-title">
          <div>其他工商信息</div>
        </div>
        <div class="form-content">
          <el-row class="form-row" :gutter="40">
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">成立日期：</div>
              <div class="form-content-value">{{ formatDateTime(detailData.issue_time) }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">核准日期：</div>
              <div class="form-content-value">{{ detailData.approval_date }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">登记状态：</div>
              <div class="form-content-value">{{ detailData.business_status }}</div>
            </el-col>
          </el-row>
          <el-row class="form-row" :gutter="40">
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">注册资本：</div>
              <div class="form-content-value">{{ detailData.reg_money }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">企业类型：</div>
              <div class="form-content-value">{{ detailData.reg_type }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">所属行业：</div>
              <div class="form-content-value">{{ detailData.industry }}</div>
            </el-col>
          </el-row>
          <el-row class="form-row" :gutter="40">
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">注册号：</div>
              <div class="form-content-value">{{ detailData.reg_number }}</div>
            </el-col>
            <el-col :span="16" class="form-content-item">
              <div class="form-content-label">经营范围：</div>
              <div class="form-content-value">{{ detailData.bussiness_des }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="rpt-content" v-else>
      <div class="search-box">
        <div class="search-control-item">
          <el-input v-model="inputValue" placeholder="请输入内容" class="input-with-select" style="width: 500px;">
            <el-select style="width: 170px;" v-model="selectType" slot="prepend" placeholder="请选择">
              <el-option label="企业名称" value="company_name"></el-option>
              <el-option label="统一社会信用代码" value="credit_code"></el-option>
            </el-select>
          </el-input>
        </div>
        <el-select class="search-control-item" style="width: 150px;" v-model="state" clearable placeholder="请选择审批状态">
          <el-option label="待审核" :value="0"></el-option>
          <el-option label="通过" :value="1"></el-option>
          <el-option label="拒绝" :value="2"></el-option>
        </el-select>
        <region class="search-control-item" v-model="regionId" />
        <el-button class="search-control-item" type="primary" icon="el-icon-search" @click="search('btn')">查询</el-button>
        <!-- <el-button class="search-control-item" type="text" style="color: unset;" icon="el-icon-upload2">导入</el-button>
        <el-button class="search-control-item" type="text" icon="el-icon-download">导出</el-button> -->
      </div>

      <el-table
        border
        v-loading="tableloading"
        :data="tableData"
        style="width: 100%"
        max-height="600"
        @row-dblclick="rowDblclick"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="company_name" label="企业名称"></el-table-column>
        <el-table-column prop="credit_code" width="150" label="统一社会信用代码"></el-table-column>
        <el-table-column prop="company_code" label="组织机构代码"></el-table-column>
        <el-table-column prop="corporation_name" label="法定代表人"></el-table-column>
        <el-table-column prop="auth_state" label="审批状态">
          <template slot-scope="scope">
            <span>{{ scope.row.auth_state === 0 ? '待审核' : scope.row.auth_state === 1 ? '通过' : '拒绝' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="business_status" label="登记状态"></el-table-column>
        <el-table-column prop="issue_time" label="成立日期">
          <template slot-scope="scope">
            <span>{{ formatDateTime(scope.row.issue_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contacts_mobile_phone" label="电话"></el-table-column>
        <el-table-column prop="contacts_mail" label="邮箱"></el-table-column>
        <el-table-column prop="province_name" label="所在省份"></el-table-column>
        <el-table-column prop="city_name" label="所在城市"></el-table-column>
        <el-table-column prop="area_name" label="所在区域"></el-table-column>
        <el-table-column prop="address" show-overflow-tooltip label="企业地址"></el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[50, 100, 200, 300]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request';
export default {
  name: 'company-list',
  data() {
    return {
      showForm: false,
      detailData: {},
      tableloading: false,
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      tableData: [],
      state: null,
      selectType: 'company_name',
      inputValue: '',
      regionId: []
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.search();
    },
    handleCurrentChange(index) {
      this.pageIndex = index;
      this.search();
    },
    search(type) {
      if (type == 'btn') this.pageIndex = 1;
      this.tableloading = true;
      let data = {
        state: this.state >= 0 ? this.state : '',
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        province_id: this.regionId[0] || '',
        city_id: this.regionId[1] || '',
        area_id: this.regionId[2] || ''
      };
      data[this.selectType] = this.inputValue;

      request({ url: '/api/rpt/company/list', data }).then(res => {
        this.tableloading = false;
        if (res.success) {
          this.tableData = res?.result?.companyList;
          this.total = res?.result?.recordCount;
        }
      });
    },
    rowDblclick(row) {
      request({ url: `/api/rpt/company/info?company_id=${row.company_id}` }).then(res => {
        console.log(res);
        if (res.success) {
          this.detailData = res.result;
        }
        this.showForm = true;
      });
    }
  }
};
</script>

<style></style>
